import gql from "graphql-tag";

export const queryMemberPrice = gql`
  query MemberPrice($country: String!, $brand: String!) {
    memberPrice(country: $country, brand: $brand)
  }
`;
